@use '@lib/assets/styles/main.scss' as *;

.cell {
  width: 1% !important;
  background: inherit;
  z-index: 1;
  position: sticky;
  right: 0;
  padding: 12px 16px !important;
  & > div {
    display: flex;
    gap: 0 16px;
  }
}
